//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'
// import { map , filter , orderBy } from 'lodash';
// import { useMemo } from 'react';


//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const audioPlayerChecker = (state) => state.audioPlayer;

//  -- Examples array selector --------

export const useAudioChecker = () => {
    const selectedData = useSelector(audioPlayerChecker, shallowEqual)
    return selectedData;
}